import React, { useState } from 'react';
import { Link, usePage } from '@inertiajs/inertia-react';
import Layout from '../Shared/Layout';
import Imgix, { Background } from 'react-imgix';
import List from '../Components/List/List';
import ListItem from '../Components/ListItem';
import Pagination from "../Components/List/Pagination";
import AppHead from "../Shared/AppHead";

const ComingSoon = ({ title, message }) => {
  const { imgixURL } = usePage().props;


  return (
    <>
      <AppHead title={ title } />

      <Background className='hero min-h-[25vh] mb-4 bg-cover'
                  src={`https://${imgixURL}/cms/homepage/jpm-plus-bg-20220912075650.jpg`}
                  imgixParams={{ auto: 'format', fit: 'crop', crop: 'center', blend: '000', bm: 'normal', balph: '40' }}
                  sizes='100vw'>
        <div className='hero-overlay bg-opacity-60'></div>
        <div className='hero-content text-center'>
          <div className='max-w-md'>
            <h1 className='text-3xl font-bold text-white pb-4'>{title}</h1>
            <p className='text-sm text-left text-white pb-3'>{message}</p>
          </div>
        </div>
      </Background>
    </>
  );
};

// Persistent layout Docs: https://inertiajs.com/pages#persistent-layouts
ComingSoon.layout = page => <Layout title='ComingSoon' children={page} data-theme='jpm' />;

export default ComingSoon;
